import bulkDownloadRepository from '@/api/bulkDownloadRepository'
import bulkDownload from '@/helpers/bulk-download'
import BulkDownloadQueuedToast from '@/layouts/components/BulkDownloadQueuedToast.vue'

// Shared add flow for both context menus (D-07). The server is the only gate
// on how many downloads a user may have active (D-18): nothing is counted here.
export default {
  data() {
    return {
      submitting: false,
    }
  },
  methods: {
    async requestBulkDownload(ids, fatherId) {
      if (this.submitting) return
      if (!Array.isArray(ids) || ids.length === 0) return

      this.submitting = true
      try {
        const response = await bulkDownloadRepository.add(ids, fatherId)
        if (response && response.data && Number(response.data.code) === 1) {
          this.showQueuedToast()
        } else {
          this.apiErrors.notifyApiError(response, bulkDownload.ADD_ERROR_OVERRIDES)
        }
      } catch (e) {
        this.apiErrors.notifyApiError(e, bulkDownload.ADD_ERROR_OVERRIDES)
      } finally {
        this.submitting = false
        this.$emit('loading', false)
      }
    },
    showQueuedToast() {
      this.$toast({
        component: BulkDownloadQueuedToast,
        props: {
          title: bulkDownload.QUEUED_TOAST_TITLE,
          text: bulkDownload.QUEUED_TOAST_TEXT,
          actionLabel: bulkDownload.QUEUED_TOAST_ACTION,
        },
        listeners: {
          'open-downloads': () => this.$bvModal.show(bulkDownload.DOWNLOADS_MODAL_ID),
        },
      }, {
        position: 'top-center',
        timeout: bulkDownload.QUEUED_TOAST_TIMEOUT_MS,
      })
    },
  },
}
